module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "covid-climate--cover.00dce393.jpg";